import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import Link from "next/link";
import { createPath } from "@/service/routing/routing";

export const SmallSquareVendorLogo = ({
  vendor,
  withoutLink = false,
}: {
  vendor: VendorVM;
  withoutLink?: boolean;
}) => {
  const Wrapper = withoutLink ? "div" : Link;
  const href = withoutLink
    ? undefined
    : createPath("vendor.show", { slug: vendor.slug });
  return (
    <Wrapper href={href} className={"flex items-center gap-2"}>
      <div
        className={`flex max-w-6 min-w-6 items-center justify-center rounded-sm border p-0.5`}
      >
        <PictureUpload
          image={vendor.logo.logoSquare}
          className="w-auto rounded-sm"
        />
      </div>

      <span className="text-muted-foreground text-sm font-medium">
        {vendor.title}
      </span>
    </Wrapper>
  );
};
